import type React from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';

import { useDashboardReskinExperiment } from '../../../../hooks/useDashboardReskinExperiment';

import { PromoteYourPetition } from './components/PromoteYourPetition';
import { ShareVisual } from './components/ShareVisual';
import { ShareYourPetition } from './components/ShareYourPetition';
import { ShareYourPetitionOffline } from './components/ShareYourPetitionOffline';
import { useGrowPetition } from './hooks/useGrowPetition';
import { GrowPetition as GrowPetitionNew } from './index_new';

export const GrowPetition: React.FC = () => {
	const { data } = useGrowPetition();
	const {
		data: { isEnabled: isReskinEnabled },
	} = useDashboardReskinExperiment();

	if (isReskinEnabled) {
		return <GrowPetitionNew />;
	}

	return (
		<Box as="section" role="group" aria-labelledby="grow-petition-title" data-testid="grow-petition-control">
			<Box
				sx={{
					display: 'grid',
					gridTemplateColumns: ['1fr', '1fr 1fr'],
					gridGap: 16,
				}}
			>
				<ShareYourPetition />
				<ShareYourPetitionOffline />
				<Box sx={{ gridColumn: ['1/1', '1/3'] }}>
					<ShareVisual />
				</Box>
				{data.shouldShowPromoteYourPetition && (
					<Box sx={{ gridColumn: ['1/1', '1/3'] }}>
						<PromoteYourPetition />
					</Box>
				)}
			</Box>
		</Box>
	);
};
